import React from 'react'
const {useCallback, useEffect, useState, useRef} = React
import {requestTimeout, clearRequestTimeout} from '@essentials/request-timeout'
export const useDebounceCallback = (callback, wait = 100, leading = false) => {
  const timeout = useRef(null) // cleans up pending timeouts when the function changes

  function _ref() {
    if (timeout.current !== null) {
      clearRequestTimeout(timeout.current)
      timeout.current = null
    }
  }

  useEffect(() => _ref, [callback, wait])
  return useCallback(
    function(...args) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this
      if (timeout.current === null && leading) callback.apply(self, args)
      else if (timeout.current !== null) clearRequestTimeout(timeout.current)
      timeout.current = requestTimeout(() => {
        timeout.current = null
        !leading && callback.apply(self, args)
      }, wait)
    },
    [callback, wait]
  )
}
export const useDebounce = (initialState, wait, leading) => {
  const _ref_0 = useState(initialState)

  const setState = _ref_0[1]
  const state = _ref_0[0]
  return [state, useDebounceCallback(setState, wait, leading)]
}
export default useDebounce
